<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="fade-transition"
  >
    <v-container
      fluid
      fill-height
      full-width
      :class="'pa-0 ma-0'"
      :style="wallpaperStyles"
      @click="unlock"
    >
      <server-clock
        v-if="$ftAC.theme.lockScreenClock"
        :style="clockStyle"
        format="h:mm A"
      />
    </v-container>
  </v-dialog>
</template>

<script>
import wallpaper from '../mixins/wallpaper'
import ServerClock from './ServerClock.vue'

export default {
  name: 'LockScreen',
  components: {ServerClock},
  mixins: [wallpaper],
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    userLockTimeout: null
    // isActive: false
  }),
  computed: {
    userLocked () {
      return this.$ftAS.userLock
    },
    clockStyle () {
      return {
        'font-size': '300%',
        'color': 'white',
        'text-shadow': 'black 0.02em 0.02em 0.1em',
        'position': 'absolute',
        'top': '50px',
        'right': '50px'
      }
    }
  },
  watch: {
    value (v) {
      if (this.userLockTimeout) clearTimeout(this.userLockTimeout)
      if (v && !this.$ftAC.userLock && this.$ftAC.terminal && this.$ftAC.terminal.id) {
        this.userLockTimeout = setTimeout(() => {
          if (this.value) {
            this.$ftAPI().setGlobalAppState({userLock: true})
          }
        }, 3000)
      }
      this.isActive = v
    },
    userLocked (v) {
      if (!v) {
        this.unlock()
      }
    }
  },
  // mounted () {
  //   this.isActive = this.value
  // },
  methods: {
    unlock () {
      clearTimeout(this.userLockTimeout)
      this.$ftAPI().setGlobalAppState({lastActivity: Date.now()})
      this.$ftAPI().setGlobalAppState({screenLocked: false})
    }
  }
}
</script>
<style>
  .ftLockOverlay {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
  }
</style>
